import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type {
  UpdateOrganizationDefaultReportCustomTextRequest,
  UpdateOrganizationDefaultReportCustomTextResponse,
} from '../../../../typings/api';

type UpdateOrganizationDefaultReportCustomTextParams = {
  organizationId: number;
  reportCustomText: string;
  shouldPropagate: boolean;
};

async function updateOrganizationDefaultReportCustomText({
  organizationId,
  reportCustomText,
  shouldPropagate,
}: UpdateOrganizationDefaultReportCustomTextParams): Promise<void> {
  await put<UpdateOrganizationDefaultReportCustomTextRequest, UpdateOrganizationDefaultReportCustomTextResponse>(
    `/api/organizations/${organizationId}/defaultReportCustomText`,
    {
      shouldPropagate,
      reportCustomText,
    },
  );
}

/**
 * Hook for updating organization default report custom text.
 */
export default function useUpdateOrganizationDefaultReportCustomText() {
  return useToastedMutation({
    mutationFn: updateOrganizationDefaultReportCustomText,
    successToastMessage: 'Default report text updated successfully',
    errorToastMessage: 'Failed to update default report text',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organization'] });
    },
  });
}
